export type Clock = {
  epoch: () => number;
  monotonic: () => number;
};

export const systemClock: Clock = {
  epoch: () => Date.now(),
  monotonic: () => performance.now(),
};

export function formatDuration(milliseconds: number): string {
  const sign = milliseconds < 0 ? '-' : '';
  const absolute = Math.abs(milliseconds);
  const minutes = Math.floor(absolute / 60_000);
  const seconds = Math.floor((absolute % 60_000) / 1_000);
  const tenths = Math.floor((absolute % 1_000) / 100);
  return `${sign}${minutes}:${seconds.toString().padStart(2, '0')}.${tenths}`;
}

export function formatDelta(milliseconds: number): string {
  if (milliseconds === 0) return '±0.0s';
  const sign = milliseconds > 0 ? '+' : '−';
  return `${sign}${(Math.abs(milliseconds) / 1_000).toFixed(1)}s`;
}
